import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AngularFireAuth } from 'angularfire2/auth';
import { User as FirebaseUser } from 'firebase/app';

import { User } from '../models/user';

import { UserService } from '../services/user.service';

@Component({
  selector: 'app-login',
  templateUrl: 'login.component.html',
  styleUrls: ['login.component.css']
})
export class LoginComponent implements OnInit {

  formValues = {
    email: '',
    password: '',
  };
  isLoggingIn = false;
  isResettingPassword  : Boolean = false;
  isEmailSending : Boolean = false;

  constructor(
    private router: Router,
    private afAuth: AngularFireAuth,
    private userService: UserService) { }

  ngOnInit() { }

  async onSubmitLoginForm() {
    if (this.isLoggingIn || this.isResettingPassword) { return; }
    this.isLoggingIn = true;
    try {
      await this.afAuth.auth.signInWithEmailAndPassword(this.formValues.email, this.formValues.password);
    this.router.navigateByUrl('/');
    } catch (error) {
      alert(error.message);
      this.afAuth.auth.signOut();
      this.isLoggingIn = false;
    }
  }

  async onSubmitResetForm(){
    console.log(this.isEmailSending);
    this.isEmailSending = true;
    await this.afAuth.auth.sendPasswordResetEmail(this.formValues.email).then(function() {
      alert('Password Reset Email Sent')
    }).catch(function(error) {
      alert(error)
    });
    this.isEmailSending = false;
  }
}



// WEBPACK FOOTER //
// D:/ThinkBIT/work-projects/confe/hosting/src/app/login/login.component.ts